import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Container, TextualLink, Button } from '@hvcgroep/design-system';
import { Helmet } from 'react-helmet';
import PageHeader from '../../components/PageHeader';
import Faqs from '../../containers/Faqs';
import { FAQ_CATEGORIES } from '../../config/constants';

const Contact: React.FC = () => {
  const { t } = useTranslation();
  const heading = t('pages.contact.title');
  const siteTitle = t('general.siteTitle');

  return (
    <Container fluid>
      <Helmet><title>{`${heading} - ${siteTitle}`}</title></Helmet>

      <div className="row">
        <div className="col-md-6 u-margin--bottom--6">
          <PageHeader heading={heading} />

          <p>
            {t('pages.contact.content.checkFaq')}
          </p>

          <p>
            <Trans
              i18nKey="pages.contact.content.contactTel"
            >
              <PhoneLink />
              <MoreLink />
            </Trans>
          </p>
        </div>
        <div className="col-md-6">
          <h3>{t('pages.contact.faqTitle')}</h3>
          <Faqs categoryId={FAQ_CATEGORIES.WARMTE} />

          <Button className="u-margin--bottom--6 u-margin--top--6" href={t('pages.contact.faqLink')}>
            {t('pages.contact.faqButton')}
          </Button>
        </div>
      </div>
    </Container>
  );
};

/**
 * A React Component to handle a nested <Trans> component that takes in a
 * `<Slot />` using the `asChild` prop.
 */
function PhoneLink({
  children,
}: {
  children?: React.ReactNode
}) {
  const { t } = useTranslation();

  return (
    <TextualLink asChild>
      <a href={`tel:${t('pages.contact.content.contactTelNumber')}`}>{children}</a>
    </TextualLink>
  );
}

function MoreLink({
  children,
}: {
  children?: React.ReactNode
}) {
  const { t } = useTranslation();

  return (
    <TextualLink asChild>
      <a href={t('pages.contact.content.contactMore')}>{children}</a>
    </TextualLink>
  );
}

export default Contact;
